module.exports = __webpack_public_path__ + "assets/img/y1.05ca4ec7.png";